import {composeWithDevTools} from 'redux-devtools-extension';

export default composeWithDevTools({
	trace: true,
	traceLimit: 25
});